export default {
  hiddenPrograms: 'Les programmes cachés',
  visiblePrograms: 'Les programmes visibles',
  needRefresh: 'Il semble que les données ne soient pas à jour',
  refreshAction: 'cliquez pour raffraichir',
  childrenProgram: 'Programmes enfants'
}
